<template>
  <div id="app">
    <router-view />
    <!-- 全局loading -->
    <div v-loading="loading" class="loading-container"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState({
      loading: state => state.app.loading > 0
    })
  }
}
</script>

<style lang="scss">
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: none;

  // 设置v-loading遮罩层背景为透明
  .el-loading-mask {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }
}
</style>
